import { useEffect, useMemo } from 'react';
import Market from '@/creditflowresearch/domain/Market';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import { useCorporateAccessibleMarkets } from '@/creditflowresearch/application/PageFilters/hooks/useCorporateAccessibleMarkets';

const useMarketsSection = () => {
  const marketFilters = useCorporateAccessibleMarkets();

  const items = useMemo(() => Market.getAll().map((market) => ({
    value: market.getId(),
    name: market.getDisplayName(),
    disabled: marketFilters.find((filter) => filter.id === market.getId())?.disabled ?? false,
  })), [marketFilters]);

  const { setRequiredFilterEmpty } = useCorporateBondScreenerSidebarFilterContext();
  const filter = useCheckboxFilter({ filterKey: 'includedMarketIds', items });

  useEffect(() => {
    setRequiredFilterEmpty(FilterSectionIds.Markets, filter.selectedValues.length === 0);
  }, [filter.selectedValues, setRequiredFilterEmpty]);

  return filter;
};

export default useMarketsSection;
